import React, { useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { Field, reduxForm } from "redux-form";
import { connect, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Modal from "../../../Components/Modal";
import { required } from "redux-form-validators";
import { renderField } from "../../../Components/Forms/renders";
import { getarrangementen } from "../../../Pages/Arrangementen/Reducers/actions";
import SelectBox from "../../../Components/Forms/selectbox";

const DatumWijzigen = ({ handleSubmit, onSubmit, ervaring, arrangementen, deelnemers, change }) => {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tijdsloten, setTijdsloten] = useState([]);
  const [datum, setDatum] = useState(null);
  const [deelnemersaantal, setDeelnemersaantal] = useState(0);
  const [geselecteerdTijdslot, setGeselecteerdTijdslot] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getarrangementen(ervaring.arrangementdatum.ervaring._id))
      .then(() => {
        setLoading(false);
        setDeelnemersaantal(deelnemers.reduce((acc, slot) => acc + parseInt(slot.aantal ?? 0, 10), 0));
      })
      .catch(() => setLoading(false));
  }, [dispatch, ervaring, deelnemers]);

  const closeModal = () => {
    setVisible(false);
    setGeselecteerdTijdslot(null);
  };
  const openModal = () => setVisible(true);

  const onFormSubmit = (values) => {
    // Roep de parent's onSubmit functie aan (verplaatsboeking)
    if (onSubmit) {
      setSubmitting(true);
      const result = onSubmit(values);

      // Als het een promise teruggeeft, wacht dan voordat we de modal sluiten
      if (result && typeof result.then === 'function') {
        result
          .then(() => {
            setSubmitting(false);
            closeModal();
          })
          .catch((error) => {
            console.error('Error bij verplaatsen boeking:', error);
            setSubmitting(false);
            // Modal blijft open bij fout zodat gebruiker het opnieuw kan proberen
          });
      } else {
        setSubmitting(false);
        closeModal();
      }
    } else {
      closeModal();
    }
  };
  const datumOpties = arrangementen.ervaringdatums?.map((datum) => ({
    _id: datum._id,
    datum: moment(datum.datum).format("DD-MM-YYYY"),
  }));
  const nieuwedatum = useSelector((state) => state.form.changedatum?.values?.nieuwedatum);

  useEffect(() => {
    if (nieuwedatum) {
      const adatum = arrangementen.ervaringdatums.find((datum) => datum._id === nieuwedatum)?.beschikbaarheid;
      setTijdsloten(adatum.tijdssloten);
      setDatum(adatum);
      setGeselecteerdTijdslot(null); // Reset selectie bij nieuwe datum
    }
  }, [nieuwedatum]);

  const handleTijdslotClick = (tijd) => {
    setGeselecteerdTijdslot(tijd);
    change('nieuwetijdslot', tijd); // Update het form veld
  };
  return (
    <>
      <div className="row">
        <div className="col-sm-5">
          <h6 className="mb-0">Datum wijzigen</h6>
        </div>
        <div className="col-sm-7 text-secondary">
          <button type="button" className="btn bnt-md btn-success" onClick={openModal}>
            <i className="fa-solid fa-calendar"></i> Datum Wijzigen
          </button>
        </div>
      </div>

      {createPortal(
        <Modal visible={visible} onClose={closeModal} width={700}>
          <div className="card" style={{ position: 'relative' }}>
            {submitting && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  borderRadius: '0.25rem',
                }}
              >
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 fw-bold">Boeking verplaatsen...</p>
              </div>
            )}
            <div className="card-header">
              <h4 className="mb-0">Datum wijzigen</h4>
            </div>
            <form onSubmit={handleSubmit(onFormSubmit)}>
              <div className="card-body">
                <Field
                  name="nieuwedatum"
                  type="text"
                  inputnaam={"datum"}
                  inputvalue={"_id"}
                  options={datumOpties}
                  component={SelectBox}
                  label="Kies een datum"
                  validate={required({ msg: "Datum is verplicht" })}
                />

                {/* Hidden field voor het geselecteerde tijdslot */}
                <Field
                  name="nieuwetijdslot"
                  type="hidden"
                  component="input"
                  validate={required({ msg: "Tijdslot is verplicht" })}
                />

                {datum?.tijdssloten && datum.tijdssloten.length > 0 && (
                  <div className="mt-4">
                    <h5 className="mb-3">Kies een tijdslot</h5>
                    <ul className="list-group" style={{ cursor: 'pointer' }}>
                      {datum.tijdssloten.map((slot) => {
                        const max = slot.max ?? 0;
                        const personen = slot.aantalpersonen ?? 0;
                        const beschikbaar = max - personen;
                        const voldoendeRuimte = beschikbaar >= deelnemersaantal;
                        const isGeselecteerd = geselecteerdTijdslot === slot.tijd;

                        return (
                          <li
                            key={slot._id}
                            onClick={() => voldoendeRuimte && handleTijdslotClick(slot.tijd)}
                            className={`list-group-item d-flex justify-content-between align-items-center ${
                              isGeselecteerd
                                ? "list-group-item-primary"
                                : !voldoendeRuimte
                                ? "list-group-item-danger"
                                : beschikbaar <= 5
                                ? "list-group-item-warning"
                                : ""
                            }`}
                            style={{
                              cursor: voldoendeRuimte ? 'pointer' : 'not-allowed',
                              opacity: voldoendeRuimte ? 1 : 0.6,
                              transition: 'all 0.2s ease',
                            }}
                          >
                            <span className="fw-bold">
                              {isGeselecteerd && <i className="fas fa-check-circle me-2 text-primary"></i>}
                              {slot.tijd}
                            </span>
                            <span className="text-end">
                              {slot.aantalreserveringen
                                ? `${slot.aantalreserveringen} reservering(en), ${personen} personen – ${beschikbaar} beschikbaar`
                                : `Geen reserveringen – ${max} beschikbaar`}
                              {!voldoendeRuimte && <strong className="text-danger ms-2">✖ Onvoldoende plek</strong>}
                              {voldoendeRuimte && beschikbaar <= 5 && <span className="text-warning ms-2">⚠ Bijna vol</span>}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
              <div className="card-footer d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={closeModal} disabled={submitting}>
                  Annuleren
                </button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Bezig...
                    </>
                  ) : (
                    'Opslaan'
                  )}
                </button>
              </div>
            </form>
          </div>
        </Modal>,
        document.body
      )}
    </>
  );
};

const ReduxFormDatumWijzigen = reduxForm({
  form: "changedatum",
  enableReinitialize: true,
})(DatumWijzigen);

const mapStateToProps = (state) => ({
  arrangementen: state.arrangementen.item,
});

export default connect(mapStateToProps, {})(ReduxFormDatumWijzigen);
